import { render, staticRenderFns } from "./PricePerTwoYears.vue?vue&type=template&id=0123517c"
import script from "./PricePerTwoYears.vue?vue&type=script&lang=js"
export * from "./PricePerTwoYears.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports